export const SIZE_VARIANT_OPTION = {
    value: 'Tamaño',
    label: 'Tamaño'
}

export const PRODUCT_VARIANT_PRICE_TABLES = {
    standard: [
        { size: '20x28', price: 345 },
        { size: '30x40', price: 384 },
        { size: '40x55', price: 455 },
        { size: '50x70', price: 501 },
        { size: '60x80', price: 553 },
        { size: '80x110', price: 826 },
        { size: '100x140', price: 1164 },
        { size: '120x168', price: 1554 }
    ],
    panoramic1: [
        { size: '20x35', price: 358 },
        { size: '25x45', price: 384 },
        { size: '35x60', price: 455 },
        { size: '45x80', price: 514 },
        { size: '60x105', price: 618 },
        { size: '75x130', price: 904 },
        { size: '90x160', price: 1294 }
    ],
    panoramic2: [
        { size: '20x45', price: 377 },
        { size: '25x60', price: 423 },
        { size: '35x80', price: 462 },
        { size: '50x120', price: 637 },
        { size: '60x140', price: 845 },
        { size: '70x165', price: 1170 }
    ],
    square: [
        { size: '20x20', price: 338 },
        { size: '30x30', price: 377 },
        { size: '45x45', price: 442 },
        { size: '60x60', price: 494 },
        { size: '100x100', price: 780 },
        { size: '120x120', price: 1170 }
    ]
}

const FORMAT_CANDIDATES = [
    { key: 'square', ratio: 1 },
    { key: 'standard', ratio: 6 / 4 },
    { key: 'panoramic1', ratio: 6 / 3.5 },
    { key: 'panoramic2', ratio: 6 / 2.5 }
]

const getImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
        const image = new Image()
        const objectUrl = URL.createObjectURL(file)

        image.onload = () => {
            URL.revokeObjectURL(objectUrl)
            resolve({
                width: image.naturalWidth,
                height: image.naturalHeight
            })
        }

        image.onerror = () => {
            URL.revokeObjectURL(objectUrl)
            reject(new Error('Could not read image dimensions'))
        }

        image.src = objectUrl
    })
}

export const resolveClosestRatioKey = (width, height) => {
    const actual = Math.max(width, height) / Math.min(width, height)
    let closest = FORMAT_CANDIDATES[0]
    let minDiff = Math.abs(actual - closest.ratio)

    FORMAT_CANDIDATES.forEach(candidate => {
        const diff = Math.abs(actual - candidate.ratio)
        if (diff < minDiff) {
            minDiff = diff
            closest = candidate
        }
    })

    return closest.key
}

const generateBarcode = () => {
    return Array.from({ length: 13 }, () => Math.floor(Math.random() * 10)).join('')
}

export const buildProductVariantsForRatio = (ratioKey, productName = '', productSku = '') => {
    const priceTable = PRODUCT_VARIANT_PRICE_TABLES[ratioKey] || PRODUCT_VARIANT_PRICE_TABLES.standard

    return priceTable.map(entry => {
        const sku = [productSku, entry.size]
            .filter(Boolean)
            .join('-')
            .replace(/\s+/g, '-')
            .toUpperCase()

        return {
            name: productName ? `${productName} ${entry.size}` : entry.size,
            barcode: generateBarcode(),
            sku,
            unitCost: 0,
            unitPrice: entry.price,
            wholeSalePrice: entry.price,
            options: [{ label: SIZE_VARIANT_OPTION.label, value: entry.size }],
            isStockManaged: false
        }
    })
}

export const buildProductVariantsFromImageFile = async (file, productName = '', productSku = '') => {
    const { width, height } = await getImageDimensions(file)
    const ratioKey = resolveClosestRatioKey(width, height)

    return {
        ratioKey,
        variants: buildProductVariantsForRatio(ratioKey, productName, productSku)
    }
}
